export default __webpack_public_path__ + "static/media/financiamento_auto.61b1eceb.png";